import React from "react";
import PropTypes from "prop-types";
import {getStyle} from "../../../services/Style";
import AddToGlobalDatabase from "./AddToGlobalDatabase";
import { groupBy as lodashGroupBy } from 'lodash-es';
import {getPublicationCategories} from "../../../services/DataGetter";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import PositionGroup from './PositionGroup';



export default class PositionList extends React.PureComponent {

    static propTypes = {
        language: PropTypes.string.isRequired,
        customerName: PropTypes.string.isRequired,
        positionList: PropTypes.array.isRequired,
        globalGateEnabled: PropTypes.bool,
		categorizePositions: PropTypes.bool,
        agency: PropTypes.string
    };

    static defaultProps = {
        agency: null
    };

    constructor(props) {
        super(props);
        this.state = {
            language: this.props.language,
            loading: true,
			categories: {}
        };
		this.getCategories();
    }

	getCategories = () => {
		getPublicationCategories(this.props.customerName, this.props.language).then(
			(categoriesResponse) => {
				categoriesResponse.json().then(json => {
					const categories = {}
					json.map(category => {
							categories[category.id] = category
						}
					)
					this.setState({categories: categories})
				})
				this.setState({loading: false})
			})
	}



	renderCategorizedPosition(logoImage, positionList) {
		//set styles
		const primaryButtonColor = getStyle(null, 'primary-button', this.props.customerName)['background-color'];
		const defaultStyle = {color: primaryButtonColor, borderBottom: "solid", paddingBottom: 5}
		let style = getStyle(null, 'categoryHeading', this.props.customerName)
		if (Object.keys(style).length===0) style = defaultStyle;
		//categories
		let {categories}= this.state;
		let groups = lodashGroupBy(positionList, function (item) {
			return categories[item.publicationCategory] ? item.publicationCategory : null
		});
		let keys = Object.keys(groups);
		//sort categories by priority
		keys.sort(function (a, b) {
			return (categories[a] ? categories[a].priority : Infinity) - (categories[b] ? categories[b].priority : Infinity)
		})
		return (
			<div className="col-lg-12">
				{keys.map(key =>
					<Accordion defaultExpanded={true}>
						<AccordionSummary>
							<div className="col-lg-12" style={style}>
								<h4>{(categories[key] ? categories[key].name : window.Translator.getSlug('WithoutCategory', this.props.language)) + ' (' + groups[key].length + ')'}
								</h4>
							</div>
						</AccordionSummary>
						<AccordionDetails>
							<div className="col-lg-12">
								<div className={"row"}>
									<PositionGroup positionList={groups[key]}
												   logoImage={logoImage}
												   language={this.props.language}
												   customerLogoStyle={logoImage}
												   customerName={this.props.customerName}
												   agency={this.props.agency} />
								</div>
							</div>
				</AccordionDetails>
			</Accordion>)}
			</div>
					)}


    render() {
        let logoImage = getStyle(null, 'logoImage', this.props.customerName);
        return (
            <div className={"section-padding-bottom flexHeight2 position-list"}>
                <div className={"container"}>
                    <div className={"row"}>
						{!this.props.agency && this.props.categorizePositions ? this.renderCategorizedPosition(logoImage, this.props.positionList)
						: (<PositionGroup positionList={this.props.positionList}
										 logoImage={logoImage}
										 language={this.props.language}
										 customerLogoStyle={logoImage}
										 customerName={this.props.customerName}
										 agency={this.props.agency} />)}
                        {this.props.globalGateEnabled && (
                            <AddToGlobalDatabase
                                language={this.state['language']}
                                customerName={this.props.customerName}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
